module.exports = __webpack_public_path__ + "files/7394c41e9dbf03db9237bc0e590c848e.svg";